import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { useBbContentPresenter } from '@Components/BigBrowse/bb2/BbContentPresenter';
import { Assets } from '@Utils/AssetsStore';
import { observer } from 'mobx-react-lite';

import { ProductCardRect } from '../../primitives/ProductCardRect';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_ThreeUp>;
  index: number;
  elevation: number;
};

export const ThreeUpImage = observer(function ThreeUpImage({
  gridCard,
  index,
  elevation,
}: Props) {
  const contentPresenter = useBbContentPresenter();
  const {
    canvasManager: { cameraPosition },
  } = useBbContentPresenter();

  const { styles } = gridCard.data!;
  const { images } = styles!.imagesPart;

  const image = images[index];

  const zRange: [number, number] = [0.1 * elevation, 0.1 * elevation + 0.09];

  const parallaxDiff = getParallaxDy({
    cameraY: cameraPosition.y,
    worldY: gridCard.worldPosition.y,
    elevation,
  });

  return (
    <ProductCardRect
      key={index + gridCard.key!}
      position={{
        x: image.position.x,
        y: image.position.y + parallaxDiff,
      }}
      size={{ width: image.size, height: image.size }}
      imageUrl={image.dto.imageUrl}
      uniqueKey={gridCard.key!}
      shadow={{ asset: Assets.ThreeUpShadow, bmpSize: 500, scale: 2 }}
      opacity={1}
      radius={25}
      onClick={() => {
        contentPresenter.openProductPanel(image.dto.id);
      }}
      animationTime={0}
      zRange={zRange}
    />
  );
});

const getParallaxDy = ({
  cameraY,
  worldY,
  elevation,
}: {
  cameraY: number;
  worldY: number;
  elevation: number;
}) => {
  const diff = worldY - cameraY;
  return diff * 0.1 * (elevation + 1);
};
